import * as typeCheck from './type-check';

export const upperFirst = (str: string): string => {
  if (!str) {
    return '';
  }

  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
};

export const capitalize = (str: string = ''): string => {
  return `${str.charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
};

export const humanizeList = (strArray: string[]): string => {
  let humanizedString = '';
  strArray.forEach((str: string, index: number) => {
    if (index < strArray.length - 2) {
      humanizedString += str + ', ';
      return;
    }

    if (index < strArray.length - 1) {
      humanizedString += str + ' och ';
      return;
    }

    if (index === strArray.length - 1) {
      humanizedString += str;
      return;
    }
  });

  return humanizedString;
};

export const interpolate = (
  string: string = '',
  args: {} | string[],
  joinSeparator: string = ', '
): string => {
  return string.replace(/{([^{}]*)}/g, (match, arg) => {
    const replacement = args[arg];

    if (typeCheck.isString(replacement)) {
      return replacement;
    }
    if (typeCheck.isNumber(replacement)) {
      return replacement;
    }
    if (typeCheck.isArray(replacement)) {
      return replacement.join(joinSeparator);
    }

    return match;
  });
};
